import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { TopBar } from './TopBar';
import { EnvironmentBanner } from './EnvironmentBanner';
import { ReauthBanner } from './ReauthBanner';
import { useSidebar } from '../../contexts/SidebarContext';
import { ReauthProvider } from '../../contexts/ReauthContext';

export default function AdminLayout() {
  const { isCollapsed } = useSidebar();

  return (
    <ReauthProvider>
      <div className="h-screen bg-slate-950 overflow-hidden">
        {/* Sidebar - fixed position */}
        <Sidebar />

        {/* Main content area - offset by sidebar width */}
        <div
          className={`
            h-screen flex flex-col
            transition-all duration-300 ease-in-out
            ${isCollapsed ? 'lg:ml-16' : 'lg:ml-64'}
          `}
        >
          {/* Environment banner (shows in non-prod) */}
          <EnvironmentBanner />

          {/* Reauth banner (shows when break-glass mode active) */}
          <ReauthBanner />

          {/* Top bar - sticky */}
          <TopBar />

          {/* Page content - scrollable, pages handle their own padding */}
          <main className="flex-1 overflow-y-auto overflow-x-hidden p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </ReauthProvider>
  );
}
